var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLayers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50053 8.91975L11.5 14.0208C11.8094 14.196 12.1906 14.196 12.5 14.0208L21.4995 8.91975C21.807 8.74558 21.9973 8.42447 21.9994 8.07611C22.0009 7.72425 21.8101 7.3986 21.4995 7.22267L12.5 2.13143C12.1906 1.95619 11.8094 1.95619 11.5 2.13143L2.50053 7.22267C2.18992 7.3986 1.99914 7.72425 2.00056 8.07611C2.0027 8.42447 2.19301 8.74558 2.50053 8.91975ZM12 4.15223L18.9996 8.07611L12 12L5.00039 8.07611L12 4.15223ZM20.4995 11.1858L12 15.9239L3.50048 11.1466C3.26997 11.0156 2.9957 10.9802 2.73852 11.0483C2.48133 11.1165 2.2625 11.2825 2.13055 11.5095C1.85918 11.9784 2.02442 12.5743 2.50053 12.8436L11.5 17.9447C11.8094 18.1199 12.1906 18.1199 12.5 17.9447L21.4995 12.8436C21.9756 12.5743 22.1408 11.9784 21.8694 11.5095C21.7375 11.2825 21.5187 11.1165 21.2615 11.0483C21.0043 10.9802 20.73 11.0156 20.4995 11.1466V11.1858ZM20.4995 15.1097L12 19.8478L3.50048 15.0704C3.26997 14.9394 2.9957 14.9041 2.73852 14.9722C2.48133 15.0404 2.2625 15.2064 2.13055 15.4334C1.85918 15.9023 2.02442 16.4981 2.50053 16.7675L11.5 21.8686C11.8094 22.0438 12.1906 22.0438 12.5 21.8686L21.4995 16.7675C21.9756 16.4981 22.1408 15.9023 21.8694 15.4334C21.7375 15.2064 21.5187 15.0404 21.2615 14.9722C21.0043 14.9041 20.73 14.9394 20.4995 15.0704V15.1097Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default ForwardRef;